import React from 'react';
import Card, { CardBody } from './Card';

function CardSkeleton(): JSX.Element {
  return (
    <Card>
      <CardBody>
        <div className="flex justify-between animate-pulse">
          <div>
            <div className="h-4 w-24 bg-gray-400 rounded" />
            <div className="mt-3 h-4 w-40 bg-gray-400 rounded" />
          </div>
          <div>
            <div className="ml-auto h-4 w-16 bg-gray-400 rounded" />
            <div className="mt-3 h-4 w-48 bg-gray-400 rounded" />
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default React.memo(CardSkeleton);
